import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
	props: {
		score: Number
	},
	setup: (props) => {
		const score = ref(props.score);
		const progressAnimationStarted = ref(false);

		onMounted(() => {
			// Start the animation of the progress bars after half a second.
			setTimeout(() => progressAnimationStarted.value = true, 500);
		});

		return { score, progressAnimationStarted };
	}
});
